import ChooseTenant from "@/modules/auth/views/ChooseTenant.vue";
import ActivateAccount from "@/modules/auth/views/ActivateAccount.vue";

const Login = () => import("./views/Login.vue");
const ForgotPassword = () => import("./views/ForgotPassword.vue");
const ResetPassword = () => import("./views/ResetPassword.vue");

const route = "/auth";

export default [
  {
    path: `${route}/login`,
    name: "auth.login",
    component: Login,
  },
  {
    path: `${route}/chooseTenant`,
    name: "auth.chooseTenant",
    component: ChooseTenant,
    meta: {
      requiresToken: true,
    },
  },

  {
    path: `${route}/forgotPassword`,
    name: "auth.forgotPassword",
    component: ForgotPassword,
  },

  {
    path: `${route}/resetPassword/:token`,
    name: "auth.resetPassword",
    component: ResetPassword,
  },
  {
    path: `${route}/activate/:token`,
    name: "auth.activate",
    component: ActivateAccount,
  },
];
